<script>
import { somenteNumeros } from '@/shared/common/functions/numero'
import { baseURL} from '@/shared/services/config'

export default {
    computed: {
        modeloCertificado: function(){
            return this.$usuarioLogado.LojaConfiguracoes.modelo_certificado_digital
        },
        versaoNf: function(){
            return somenteNumeros(this.$usuarioLogado.LojaConfiguracoes.versao_nf)
        },
        urlBase: function (){ 
            return this.$usuarioLogado.LojaConfiguracoes.modelo_certificado_digital == 1 
            ? baseURL
            : 
                'http://' 
                + this.$usuarioLogado.LojaConfiguracoes.ip_app_local 
                + ':' 
                + this.$usuarioLogado.LojaConfiguracoes.porta_app_local
        }
    },
    data(){
        return {
            tituloMensagem: 'Processo em andamento',
        }
    },
    methods: {
        async api(url, parametros = {}, metodo = 'post'){
            const cabecalho = 
                this.modeloCertificado == 1
                    ? this.$api.headers
                    : {
                        'Content-Type': 'application/json',
                    }
            let retorno = []
            this.$loading.show()
            try {
                retorno = await this.$api.axios(
                    url, 
                    parametros, 
                    metodo, 
                    this.urlBase, 
                    cabecalho
                )
            } catch {
                this.$dialog.error(
                    this.modeloCertificado == 1
                    ? 'Ocorreu um erro, verifique sua conexão com a internet!'
                    : 'O aplicativo desktop não está em execução!'
                )
            }
            this.$loading.hide()
            return retorno
        },
        validaPlanoRecurso(){
            if(this.$empresaPlano.recurso_notas_fiscais == 1){
                return true
            }else{
                this.$dialog.error(
                    'O seu plano atual não lhe permite emitir notas fiscais!'
                )
                return false
            }
        },
        async validaAplicativoA3(){
            // if(!this.validaNavegador()){
            //     return false             
            // }
            this.mensagemProcessamento(
                'Validando certificado digital...'
            )
            const retorno = await this.api('/iniciar_conexao', {
                nomeApp: this.$app.nome_divulgacao,
                urlApp: this.$app.link_principal,
                iconeApp: this.$app.favicon_divulgacao,
            })
            this.removeMensagemProcessamento()
            if(retorno != true){
                this.$dialog.error(
                    'O aplicativo desktop não está em execução!'
                )
            }
            return retorno == true
        },
        validaNavegador(){
            const chrome 
                = /Chrome/.test(navigator.userAgent) 
                && /Google Inc/.test(navigator.vendor)
            if(!chrome){
                this.$dialog.error(
                    'Este navegador não é compatível com o aplicativo, utilize o navegador Google Chrome'
                )
            }
            return chrome
        },
        async executaAplicacao(){
            if(this.modeloCertificado == 1){
                return true
            }
            return await this.validaAplicativoA3()
        },
        mensagemProcessamento(mensagem){
            this.removeMensagemProcessamento()
            this.$notify.default(
                mensagem, 
                this.tituloMensagem,
                {
                    autoHideDelay: 100000,
                    noFade: true
                }
            )
        },
        removeMensagemProcessamento(){
            this.$notify.close()
        },
        async assinarXml(envio){
            this.mensagemProcessamento(
                'Assinando XML...'
            )
            const retorno = await this.api(
                `${this.$urlBase}/manifestos/assina_xml`, 
                envio
            )
            if(!retorno.sucesso){
                this.removeMensagemProcessamento()
                this.$dialog.error(
                    retorno.mensagem
                )
            }
            return retorno
        },
    },
}
</script>